import { render, staticRenderFns } from "./Appointments.vue?vue&type=template&id=084fdcca&scoped=true&"
import script from "./Appointments.vue?vue&type=script&lang=js&"
export * from "./Appointments.vue?vue&type=script&lang=js&"
import style0 from "./Appointments.vue?vue&type=style&index=0&id=084fdcca&scoped=true&lang=css&"
import style1 from "./Appointments.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084fdcca",
  null
  
)

export default component.exports